import React, {useContext, useEffect, useState} from "react";
import TrackVASContext from "../../../TrackVASContext";
import {PageTitle} from "../../../../_metronic/layout/core";
import {getAllOrganizationsWithBilling} from "../../generic/crud";
import {BillingConfigDialog} from "./BillingConfigDialog";
import {useNavigate} from "react-router-dom";
import {simpleDateFormat} from "../../../utils/Utils";

export function SABillingPage() {
    const myData = useContext(TrackVASContext);
    const navigate = useNavigate();
    const [orgs, setOrgs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedOrg, setSelectedOrg] = useState(null);

    const profileBreadCrumbs = [
        {
            title: "Home",
            path: "/sadashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    function loadData() {
        setIsLoading(true);
        getAllOrganizationsWithBilling().then(({data}) => {
            setOrgs(data);
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        });
    }

    function openBillingConfig(org) {
        setSelectedOrg(org);
        setShowModal(true);
    }

    function openPaymentHistory(org) {
        const totalMonthly = (org.monthlyBillingAmount || 0) * (org.currentBranchCount || 0);
        navigate("/super-admin/billing/" + org.id + "/payments", {
            state: {
                orgName: org.name,
                monthlyAmount: totalMonthly,
                billingStatus: org.billingStatus,
                createdOn: org.createdOn
            }
        });
    }

    const handleClose = () => setShowModal(false);

    useEffect(() => {
        myData.setBaseData({
            toolBarButtons: [],
        });
        loadData();

        return () => {
            myData.setBaseData({
                toolBarButtons: []
            });
        };
    }, []);

    function getBillingStatusBadge(status) {
        switch (status) {
            case "ACTIVE":
                return <span className="badge badge-light-success">Active</span>;
            case "WARNING":
                return <span className="badge badge-light-warning">Warning</span>;
            case "SUSPENDED":
                return <span className="badge badge-light-danger">Suspended</span>;
            case "CANCELLED":
                return <span className="badge badge-light-dark">Cancelled</span>;
            case "DEMO":
            default:
                return <span className="badge badge-light-info">Demo</span>;
        }
    }

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Organization Billing</PageTitle>
            <div className="card card-body">
                {isLoading && <div className="text-center py-10"><span>Loading...</span></div>}
                {!isLoading && (
                    <div className="table-responsive">
                        <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                            <thead>
                                <tr className="fw-bold text-muted">
                                    <th className="min-w-150px">Organization</th>
                                    <th className="min-w-100px">Billing Status</th>
                                    <th className="min-w-150px">Monthly Billing</th>
                                    <th className="min-w-120px">Branches</th>
                                    <th className="min-w-100px">Admin</th>
                                    <th className="min-w-100px">Created</th>
                                    <th className="min-w-200px text-end">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orgs.map((org) => (
                                    <tr key={org.id}>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <div className="d-flex justify-content-start flex-column">
                                                    <span className="text-dark fw-bold fs-6">{org.name}</span>
                                                    <span className="text-muted fw-semibold text-muted d-block fs-7">{org.phone}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>{getBillingStatusBadge(org.billingStatus)}</td>
                                        <td>
                                            <span className="text-dark fw-bold fs-6">
                                                ₹{((org.monthlyBillingAmount || 0) * (org.currentBranchCount || 0)).toLocaleString()}
                                            </span>
                                            <span className="text-muted fw-semibold d-block fs-8">
                                                ₹{(org.monthlyBillingAmount || 0).toLocaleString()} x {org.currentBranchCount || 0} branches
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-dark fw-bold fs-6">
                                                {org.currentBranchCount} / {org.maxAllowedBranches}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="text-muted fw-semibold">{org.adminUserName}</span>
                                        </td>
                                        <td>
                                            <span className="text-muted fw-semibold">
                                                {org.createdOn ? simpleDateFormat(org.createdOn) : "-"}
                                            </span>
                                        </td>
                                        <td className="text-end">
                                            <button
                                                className="btn btn-sm btn-light-primary me-2"
                                                onClick={() => openBillingConfig(org)}>
                                                <i className="fa fa-cog me-1"></i>Configure
                                            </button>
                                            <button
                                                className="btn btn-sm btn-light-success"
                                                onClick={() => openPaymentHistory(org)}>
                                                <i className="fa fa-history me-1"></i>Payments
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {orgs.length === 0 && (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted py-10">
                                            No organizations found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            <BillingConfigDialog
                show={showModal}
                handleClose={handleClose}
                org={selectedOrg}
                onSave={loadData}
            />
        </>
    );
}
